import { UserData } from '@/entities/User';

type KeyRecord = Record<keyof UserData, string>;

export const LABELS: Partial<KeyRecord> = {
    firstName: 'Имя',
    secondName: 'Фамилия',
    middleName: 'Отчество',
    phoneNumber: 'Номер телефона',
    email: 'Почта',
    birthDate: 'Дата рождения',
    passportIssueDate: 'Дата выдачи паспорта',
    passportSeries: 'Серия',
    passportNumber: 'Номер',
    passportIssuedBy: 'Кем выдан',
    passportDepartmentCode: 'Код подразделения',
    snils: 'СНИЛС',
    inn: 'ИНН',
    address: 'Адрес регистрации',
    addressFact: 'Адрес проживания',
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const ALLOWED_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
